import { all, takeEvery, put } from 'redux-saga/effects';
import { notification } from '@iso/components';
import actions from './actions';
import siteConfig from '@iso/config/site.config';
const gaxios = require('gaxios');
gaxios.instance.defaults = {
  baseURL: siteConfig.siteUrl.API_URL,
  headers: {
    Authorization: localStorage.getItem('access_token')
  }
}

const headers = {
  Authorization: localStorage.getItem('access_token'),
  AuthId: localStorage.getItem('id_token'),
  SiigoAuth: localStorage.getItem('siigo_token'),
}

export function* getInvoice(action) {
  let ULRDestino = `api/facturacion${action.query ? '?' + action.query : ""}`;
  console.log("traigo facturas", ULRDestino)
  // obtengo loadingInvoices

  const res = yield gaxios.request({
    url: ULRDestino,
    headers
  });

  console.log(res)

  if (res.data.success) {
    let newInvoices = res.data.facturas;
    if (!res.data.facturas[0]?.RecibosVinculadosObject) {
      newInvoices = res.data.facturas.map(item => {
        item.RecibosVinculadosObject = item.recibosVinculados
        return item;
      })
    }
    yield put({
      type: actions.UPDATE_INVOICE,
      invoices: newInvoices,
    });

    if (res.data.paginationInfo) {
      yield put({
        type: actions.SET_PAGINATION_INFO,
        payload: res.data.paginationInfo,
      });
    }

  } else {
    notification('error', res.data.msg);
  }
}

export function* deleteInvoice(action) {
  let ULRDestino = "api/facturacion/" + action.id;
  let metodo = "DELETE";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    data: {
      cajero: localStorage.getItem('id_token'),
      motivo: action.motivo || 'Anulación de factura',
    },
  });
  if (res.data.success) {
    notification('success', res.data.msg)
    yield put({
      type: actions.GET_INVOICE,
    });
  } else {
    notification('error', res.data.msg);
  }
}

export function* deleteHardInvoice(action) {
  let ULRDestino = "api/facturacion/completeDelete/" + action.id;
  let metodo = "DELETE";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
  });
  if (res.data.success) {
    notification('success', res.data.msg)
    yield put({
      type: actions.GET_INVOICE,
    });
  } else {
    notification('error', res.data.msg);
  }
}

export function* updateInvoiceSaga(action) {
  let ULRDestino = "api/facturacion/" + action.invoice._id;
  let metodo = "PUT";
  const res = yield gaxios.request({
    url: ULRDestino,
    data: action.invoice,
    method: metodo,
  });
  if (res.data.success) {
    notification('success', res.data.msg)
    yield put({
      type: actions.GET_INVOICE,
    });
    yield put({
      type: actions.SET_CURRENT_INVOICE,
      invoice: action.invoice,
    });
  } else {
    notification('error', res.data.msg);
  }
}

export function* saveInvoiceSaga(action) {
  let ULRDestino = "api/facturacion";
  let metodo = "POST";
  try {
    const res = yield gaxios.request({
      url: ULRDestino,
      data: {
        ...action.invoice,
        esContadorPrueba: process.env.NODE_ENV === 'development' ? true : false,
        cajero: localStorage.getItem('id_token'),
      },
      headers: {
        Authorization: localStorage.getItem('siigo_token')
      },
      method: metodo,
    });
    if (res.data.success) {
      yield put({
        type: actions.GET_INVOICE,
      });
      yield put({
        type: actions.SET_CURRENT_INVOICE,
        invoice: res.data.factura,
      });
      yield action.history.history.push('/dashboard/lista_ventas');
    } else {
      const mensaje = res.data?.error?.response?.data?.Errors[0]?.Message
      console.log(mensaje)
      notification('error', mensaje);
    }
  } catch (error) {
    console.log(error)
    notification('error', 'Error al guardar la factura. Por favor, inténtelo de nuevo.');
  }
}

export function* prepararDIANSaga(action) {
  yield put({ type: actions.SET_DIAN_LOADING, payload: true });
  try {
    const res = yield gaxios.request({
      url: 'api/dian/preparar',
      method: 'POST',
      data: { facturaIds: action.facturaIds },
      headers,
    });
    if (res.data?.success || res.data?.resultados) {
      yield put({ type: actions.DIAN_PREPARAR_SUCCESS, payload: res.data });
      // Recargar la tabla para que los estados DIAN se actualicen
      yield put({ type: actions.GET_INVOICE });
      const exitosas = res.data.resultados?.length || 0;
      const errores  = res.data.errores?.length   || 0;
      if (exitosas > 0) notification('success', `${exitosas} factura(s) preparadas. CUFE calculado y XML guardado en S3.`);
      if (errores  > 0) notification('error',   `${errores} factura(s) con error. Revisa el detalle.`);
    } else {
      yield put({ type: actions.DIAN_PREPARAR_ERROR, msg: res.data?.msg || 'Error desconocido' });
      notification('error', res.data?.msg || 'Error al preparar facturas para DIAN');
    }
  } catch (err) {
    const msg = err?.response?.data?.msg || err.message || 'Error de conexión con el servidor';
    yield put({ type: actions.DIAN_PREPARAR_ERROR, msg });
    notification('error', msg);
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_INVOICE, getInvoice),
    yield takeEvery(actions.UPDATE_EDIT_INVOICE, updateInvoiceSaga),
    yield takeEvery(actions.SAVE_INVOICE, saveInvoiceSaga),
    yield takeEvery(actions.DELETE_INVOICE, deleteInvoice),
    yield takeEvery(actions.DELETE_HARD_INVOICE, deleteHardInvoice),
    yield takeEvery(actions.DIAN_PREPARAR, prepararDIANSaga),
  ]);
}